import React, { useState } from 'react';
import { Poppins, Settings } from 'src/common';
import CommonMenu from 'src/components/CommonMenu';
import { AssessmentSelect } from 'src/components/select/AssessmentSelect';
import { DashboardQuery } from 'src/graphql/_generated';
import styled from 'styled-components';
import { useExportJob } from 'src/hooks/useExportJob';

const Div = styled.div``;

interface HeadProps {
  isEmpty: boolean;
  selectedAssessment: string;
  setSelectedAssessmentStored: (assessmentId: string) => void;
  data?: DashboardQuery;
}

export const Head: React.FC<HeadProps> = ({
  isEmpty,
  selectedAssessment,
  setSelectedAssessmentStored,
  data,
}) => {
  const [anchorEl, setAnchorEl] = useState<React.MouseEvent['currentTarget'] | null>(null);
  // Menu close is the only "close" we have here — there's no modal — so the
  // hook's onClose just resets anchorEl, which the click handler already did.
  const { triggerExport, loading } = useExportJob({ onClose: () => {} });

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePdfClick = (e: React.MouseEvent<HTMLLIElement>) => {
    e.stopPropagation();
    handleClose();
    triggerExport({
      type: 'insights',
      format: 'pdf',
      assessmentId: selectedAssessment,
    });
  };

  if (!data) return null;

  return (
    <>
      <CommonMenu onPdfClick={handlePdfClick} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} />
      <Div className="panel">
        <Poppins px={32} weight={600}>
          Insights
        </Poppins>
        {!isEmpty && (
          <div className="panel">
            <AssessmentSelect value={selectedAssessment} onChange={(opt) => setSelectedAssessmentStored(opt.value)} />
            <Settings
              active={!!anchorEl || loading}
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(e.currentTarget);
              }}
              variant="button"
              data-cy="common-menu"
            />
          </div>
        )}
      </Div>
    </>
  );
};
